import { useEffect, ReactNode } from 'react';
import posthog from 'posthog-js';
import { useAuth0 } from '@auth0/auth0-react';

interface PostHogProviderProps {
  children: ReactNode;
}

export function PostHogProvider({ children }: PostHogProviderProps) {
  const { user, isAuthenticated } = useAuth0();

  useEffect(() => {
    const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
    const posthogHost = import.meta.env.VITE_POSTHOG_HOST || 'https://us.posthog.com';

    if (posthogKey) {
      posthog.init(posthogKey, {
        api_host: posthogHost,
        capture_pageview: true,
        capture_pageleave: true,
      });
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated && user) {
      posthog.identify(user.sub, {
        email: user.email,
        name: user.name,
      });
    } else if (!isAuthenticated) {
      // Reset identity on logout to prevent analytics leakage
      posthog.reset();
    }
  }, [isAuthenticated, user]);

  return <>{children}</>;
}
